
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-de-confidentialitate",
      function () {
        return require("private-next-pages/politica-de-confidentialitate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politica-de-confidentialitate"])
      });
    }
  